import {
  deliverParams,
  updateQueryString,
} from '@tencent/imutils/dist/esm/util_09_url';

export function noop() {}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

export function promiseWrapper(p) {
  return new Promise(resolve => {
    p.then(i => resolve([null, i])).catch(e => resolve([e, null]));
  });
}

const deliverParamList = [
  'from',
  'fr',
  'qz_gdt',
  'gdt_vid',
  'clickid',
  'from_ke',
  'ext_youdao',
  'ne_yx_clickid',
];
export function deliverReportParams(url, params) {
  if (!params) {
    return deliverParams(url, deliverParamList);
  }
  return deliverParamList.reduce(
    (acc, key) =>
      params.hasOwnProperty(key)
        ? updateQueryString(acc, key, params[key])
        : acc,
    url
  );
}

export function downloadString(text, fileType, fileName) {
  const blob = new Blob([text], { type: fileType });

  const a = document.createElement('a');
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
  }, 1500);
}

export function isChildrenEmpty(children) {
  if (!children) {
    return true;
  }
  if (Array.isArray(children)) {
    return children.length <= 0;
  }
  return false;
}

export function checkLoaded() {
  return (
    document.readyState === 'complete' || document.readyState === 'interactive'
  );
}

export function preventSyntheticEvent(e) {
  e.preventDefault && e.preventDefault();
  e.stopPropagation && e.stopPropagation();
  return false;
}

export const fudaoMainColor = '#08cb6a';

export const gradeMap = {
  5001: '高一',
  5002: '高二',
  5003: '高三',
  6001: '初一',
  6002: '初二',
  6003: '初三',
  7001: '一年级',
  7002: '二年级',
  7003: '三年级',
  7004: '四年级',
  7005: '五年级',
  7006: '六年级',
};

export const gradeList = Object.entries(gradeMap).map(([key, value]) => ({
  key,
  value,
}));

export const subjectMap = {
  6001: '语文',
  6002: '数学',
  6003: '化学',
  6004: '物理',
  6005: '英语',
  6006: '生物',
  6007: '政治',
  6008: '历史',
  6009: '地理',
  6010: '讲座',
  7057: '编程',
  7058: '科学',
};

export const subjectList = Object.entries(subjectMap).map(([key, value]) => ({
  key,
  value,
}));
